"use strict";var loader = require('../../common/loader');
var _require = require('./elements'),getElements = _require.getElements,playIcon = _require.playIcon;
var versions = require('./versions.json');
var MAX_RETRIES = 3;
var DEFAULT_SPINNER_TIMEOUT = 2000;

var videoConfig = {
  addBigPlayButton: false,
  addSeekBar: true,
  controlPanelElements: [
  'play_pause',
  'time_and_duration',
  'spacer',
  'mute',
  'report',
  'fullscreen',
  'overflow_menu'],

  overflowMenuButtons: ['captions'] };


module.exports = {
  isPlaylist(source) {
    var type = source.type && source.type.toLowerCase();
    var src = source.src;
    if (type === 'dash' || type === 'hls') {
      return true;
    } else if (source.src) {
      return (
        src.indexOf('.mpd') === src.length - 5 || src.indexOf('.m3u8') === src.length - 6);

    }
    return false;
  },

  handleResize() {
    if (!this.input.width && this.video) {
      var _this$root$getBoundin = this.root.getBoundingClientRect(),containerWidth = _this$root$getBoundin.width;
      this.containerEl.setAttribute('width', containerWidth);
    }
  },

  handlePause(originalEvent) {
    // On IOS, the controls force showing up if the video exist fullscreen while playing.
    // This forces the controls to always hide
    this.video.controls = false;

    this.emit('pause', { originalEvent, player: this.player });
  },

  handlePlaying(originalEvent) {
    this.showControls();

    if (this.input.playView === 'fullscreen') {
      this.video.requestFullscreen();
    }
    this.state.played = true;
    this.emit('play', { originalEvent, player: this.player });
  },

  handleVolumeChange(originalEvent) {
    this.emit('volume-change', {
      originalEvent,
      volume: this.video.volume,
      muted: this.video.muted });

  },

  handleError(err) {
    this.state.failed = true;
    this.state.isLoaded = true;

    if (this.ui) {
      this.ui.configure({
        addBigPlayButton: false });

    }
    this.emit('load-error', err);
  },

  showControls() {
    var copyConfig = Object.assign({}, videoConfig);
    copyConfig.controlPanelElements = [].concat(videoConfig.controlPanelElements);
    if (this.state.volumeSlider === true) {
      var insertAt =
      copyConfig.controlPanelElements.length - 2 > 0 ?
      copyConfig.controlPanelElements.length - 2 :
      copyConfig.controlPanelElements.length;
      copyConfig.controlPanelElements.splice(insertAt, 0, 'volume');
    }
    this.ui.configure(copyConfig);
    this.video.controls = false;
  },
  takeAction() {
    switch (this.state.action) {
      case 'play':
        this.video.play();
        break;
      case 'pause':
        this.video.pause();
        break;
      default:}

  },

  onInput(input) {
    if (this.video) {
      if (input.width || input.height) {
        this.containerEl.setAttribute('style', {
          width: input.width + "px" });

      }
      this.video.volume = input.volume;
      this.video.muted = input.muted;
    }

    // Check if action is changed
    if (this.state.action !== input.action) {
      this.state.action = input.action;
      this.takeAction();
    }
    if (input.volumeSlider === true) {
      this.state.volumeSlider = input.volumeSlider;
    }
  },

  onCreate() {
    this.state = {
      volumeSlider: false,
      action: '',
      showLoading: false,
      isLoaded: true,
      failed: false,
      played: false };

  },

  loadCDN(immediate) {var _this = this;
    var _timeout =
    window.requestIdleCallback ||
    function (handler, arg) {
      return setTimeout(function () {
        handler();
      }, arg.timeout);
    };

    var _cancel =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };

    this.retryTimes = 0;
    this.state.failed = false;
    this.state.isLoaded = false;

    _cancel(this.loadDelay);
    if (!immediate) {
      this.state.showLoading = false;
      this.loadDelay = _timeout(function () {return _this._loadCDN();}, { timeout: 100 });
    } else {
      this.state.showLoading = true;
      this._loadCDN();
    }
  },

  _addTextTracks() {var _this2 = this;
    (this.input.tracks || []).forEach(function (track) {
      _this2.player.addTextTrack(track.src, track.srclang, track.kind);
    });

    var _this$player$getTextT = this.player.getTextTracks(),track = _this$player$getTextT[0];
    if (track) {
      this.player.selectTextTrack(track.id); // => this finds the id and everythings fine but it does nothing
    }
  },

  _loadSrc(index) {var _this3 = this;
    var currentIndex = index || 0;
    var src = this.input.sources[currentIndex];
    var nextIndex;
    if (src && this.input.sources.length > currentIndex + 1) {
      nextIndex = currentIndex + 1;
    }

    this.player.
    load(src.src).
    then(function () {
      _this3._addTextTracks();
      _this3.state.isLoaded = true;
      _this3.state.failed = false;
    }).
    catch(function (err) {
      if (err.code === 7000) {
        // Load interrupted by another load, just return
        return;
      } else if (err.code === 11) {
        // Retry, player is not loaded yet
        setTimeout(function () {return _this3._loadSrc(currentIndex);}, 0);
      }
      if (nextIndex) {
        setTimeout(function () {return _this3._loadSrc(nextIndex);}, 0);
      } else {
        _this3.handleError(err);
      }
    });
  },

  _attach() {
    var _getElements = getElements(this),Report = _getElements.Report,TextSelection = _getElements.TextSelection;
    // eslint-disable-next-line no-undef,new-cap
    this.ui = new shaka.ui.Overlay(
    this.player,
    this.containerEl,
    this.video,
    this.input.reportText || '');


    // eslint-disable-next-line no-undef,new-cap
    shaka.ui.Controls.registerElement('report', new Report.Factory(this.input.reportText));

    // eslint-disable-next-line no-undef,new-cap
    shaka.ui.Controls.registerElement('captions', new TextSelection.Factory());

    this.ui.configure({
      addBigPlayButton: true,
      controlPanelElements: [],
      addSeekBar: false });


    // Replace play icon
    if (this.el) {
      var playButton = this.el.querySelector('.shaka-play-button');
      playButton.removeAttribute('icon');
      playIcon.renderSync().appendTo(playButton);

      var shakaSpinner = this.el.querySelector('.shaka-spinner');
      if (shakaSpinner) {
        setTimeout(function () {
          shakaSpinner.hidden = true;
        }, this.input.spinnerTimeout || DEFAULT_SPINNER_TIMEOUT);
      }
    }
  },

  _loadCDN() {var _this4 = this;
    var version = this.input.cdnVersion || versions.shaka;
    var cdnBaseUrl = "https://ir.ebaystatic.com/cr/v/c1/ebayui/shaka/v" + version + "/";
    var cdnUrl = this.input.cdnUrl || cdnBaseUrl + "/shaka-player.ui.js";
    var cssUrl = this.input.cssUrl || cdnBaseUrl + "/controls.css";

    loader([cdnUrl, cssUrl], ['src', 'css']).
    then(function () {
      // eslint-disable-next-line no-undef,new-cap
      shaka.polyfill.installAll();

      // eslint-disable-next-line no-undef,new-cap
      _this4.player = new shaka.Player(_this4.video);
      _this4._attach();

      _this4._loadSrc();
    }).
    catch(function (err) {
      clearTimeout(_this4.retryTimeout);
      _this4.retryTimes += 1;
      if (_this4.retryTimes < MAX_RETRIES) {
        _this4.retryTimeout = setTimeout(function () {return _this4._loadCDN(cdnUrl);}, 2000);
      } else {
        _this4.handleError(err);
      }
    });
  },

  onMount() {
    this.root = this.getEl('root');
    this.video = this.root.querySelector('video');
    this.containerEl = this.root.querySelector('.video-player__container');
    this.video.volume = this.input.volume || 1;
    this.video.muted = this.input.muted || false;

    this.subscribeTo(this.video).
    on('playing', this.handlePlaying.bind(this)).
    on('pause', this.handlePause.bind(this)).
    on('volumechange', this.handleVolumeChange.bind(this));

    this._loadVideo();
  },

  onDestroy() {
    if (this.ui) {
      this.ui.destroy();
    }
  },

  _loadVideo() {
    this.state.isLoaded = false;

    if (document.readyState === 'complete') {
      this.loadCDN();
    } else {
      this.subscribeTo(window).once('load', this.loadCDN.bind(this));
    }

    this.handleResize();
  } };